import { getFeaturesCentroidCoordinates } from 'screens/Property/helpers/mapApiHelpers';

const cropZoneGenerator = (values, field, baseGeometry, newGeometry) => {
  const { crop, name, reportedArea } = values;
  return {
    name,
    cropId: crop,
    reportedArea: reportedArea ? parseFloat(reportedArea) : 0,
    fieldId: field?.id,
    propertyId: field?.propertyId,
    geometry: baseGeometry,
    coordinates: getFeaturesCentroidCoordinates(newGeometry).toString()
  };
};

export default cropZoneGenerator;
